import React, { useState } from "react";
import {
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  Row,
} from "reactstrap";
import "./LoginPopUp.css";
import { FcGoogle } from "react-icons/fc";
import {
  FaArrowLeft,
  FaEye,
  FaEyeSlash,
  FaFacebook,
  FaSquareFacebook,
} from "react-icons/fa6";
import "../../styles/authentications.css";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { toast } from "react-toastify";
import axiosClient from "../../axios-client";
import FacebookLogin from "@greatsumini/react-facebook-login";
import { ForgotPw } from "../Header/Data2";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { countryCodes } from "../CountryCodes";
import Select from "react-select";
import { getWishcount } from "../../redux/slices/settingSlice";
import { useDispatch } from "react-redux";
import { GoogleLoginButton } from "./GoogleLoginButton";
import { userAction } from "../../redux/slices/userSlice";
const LoginPopUp = ({ isOpen, closePopup }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [smData, setSmData] = useState({});
  const [userName, setUserName] = useState("");
  const [responseData, setResponseData] = useState({});
  const [selectedCountry, setSelectedCountry] = useState("+1");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [step, setStep] = useState(1);
  const [forgot, setForgot] = useState(false);
  const [mobile, setMobile] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [receivedOtp, setReceivedOtp] = useState("");
  const [singInType, setSingInType] = useState("signin");
  const [rememberMe, setRememberMe] = useState(false);

  // Capture the intended redirect URL from the current location
  const intendedUrl = location.pathname + location.hash;

  const isVendorDetailsPage = intendedUrl.includes("/vendordetails");

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const countryOptions = countryCodes.map((country) => ({
    label: `${country.name} (${country.dial_code}) `,
    value: country.dial_code,
  }));

  const handleSuccess = (response) => {
    console.log("Google login successful", response);
    // let token = response;
    let googleUserData = response;
    try {
      // if (token) {
      if (googleUserData) {
        // const [headerBase64, payloadBase64, signature] = token.split(".");
        // const decodedPayload = JSON.parse(window.atob(payloadBase64));
        singInType === "signup"
          ? smRegister(googleUserData)
          : smLogin(googleUserData);
        setEmail(googleUserData.email);
        console.log(googleUserData, "user details");
      } else {
        console.error("Token is null or undefined");
      }
    } catch (error) {
      console.error("Error decoding JWT:", error.message);
    }
  };

  const smLogin = async (googleUserData) => {
    console.log(googleUserData, "email");
    try {
      const response = await axiosClient.post("auth/login", {
        email: email || googleUserData.email,
        password: null,
        ssologin: true,
      });
      if (response.data.statusCode === 200) {
        setSmData(response.data);
        setEmail(response.data.user.Email);
        setStep(2);
      } else {
        await callSignupApi(googleUserData);
      }
    } catch (error) {
      smRegister(googleUserData);
    }
  };

  const smRegisterPopup = async (googleUserData) => {
    const originalUrl = googleUserData.picture;
    try {
      axiosClient
        .post("auth/register", {
          Email: email || googleUserData.email,
          ssologin: true,
          RoleID: 2,
          UserName: googleUserData.email,
          Photo: originalUrl,
        })
        .then((response) => {
          console.log(response, "response");
          if (response.data.statusCode === 200) {
            setSmData(response.data);
            setStep(2);
          } else if (response.data.statusCode === 404) {
            toast.error(response.data.message);
          }
        })
        .catch((error) => {
          console.error("Error during login:", error);
          toast.error("User already exists, please login", {
            theme: "colored",
          });
        });
    } catch (error) {
      console.error("Error fetching image:", error);
      toast.error("Failed to fetch image", {
        theme: "colored",
      });
    }
  };

  const smRegister = async (googleUserData) => {
    try {
      const response = await axiosClient.post("auth/register", {
        Email: email || googleUserData.email,
        ssologin: true,
        RoleID: 2,
        UserName: googleUserData.email,
        Photo: googleUserData.picture,
      });
      if (response.data.statusCode === 200) {
        setSmData(response.data);
        setStep(2);
      } else if (response.data.statusCode === 404) {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error during login:", error);
      toast.error("Error during login", {
        theme: "colored",
      });
    }
  };

  const callSignupApi = async (googleUserData) => {
    try {
      const signupResponse = await axiosClient.post("auth/register", {
        UserName: googleUserData.name,
        Email: email || googleUserData.email,
        CountryCode: "",
        Phone: "",
        Password: "string",
        RoleID: 2,
        isVerified: 0,
      });
      if (signupResponse.data.statusCode === 200) {
        setStep(2);
      } else {
        toast.error(signupResponse.message, { theme: "colored" });
      }
    } catch (error) {
      console.error("Error during signup:", error);
      toast.error("Error during signup");
    }
    setEmail(googleUserData.email);
  };

  const handleError = () => {
    toast.error("cont login");
  };

  const handleFBSuccess = (response) => {
    console.log("FB login successful", response);
    // if (singInType === "signup") {
    //   smRegisterPopup(response);
    // }
  };

  const handleFbFail = (error) => {
    console.log("Login Failed!", error);
    toast.error("can't login");
  };

  const handleFBProfileSuccess = (response) => {
    console.log("profile", response);
    if (singInType === "signup") {
      smRegister(response);
    } else {
      smLogin(response);
    }
  };

  const submitForm = async () => {
    try {
      const response = await axiosClient.post("auth/login", {
        email: email,
        password: password,
        ssologin: false,
      });
      if (response.data.statusCode === 200) {
        setResponseData(response.data);
        setStep(2);
        if (rememberMe) {
          localStorage.setItem(
            "credentials",
            JSON.stringify({ email, password })
          );
        } else {
          localStorage.removeItem("credentials");
        }
      } else {
        toast.error(response.message, { theme: "colored" });
      }
    } catch (error) {
      console.error("Error during login:", error);
      toast.error("Error during login");
    }
  };

  const ForgotLink = async () => {
    await ForgotPw(email);
    toast.success("Reset link send to email");
  };

  const handleLoginSubmit = (e) => {
    e.preventDefault();
    if (forgot) {
      ForgotLink();
    } else {
      submitForm();
    }
  };

  const handleOtpSent = async (e) => {
    e.preventDefault();
    if (isLoading) return;
    setIsLoading(true);
    if (mobile && selectedCountry && mobile.length === 10) {
      try {
        const userData = {
          email: email || smData.user.Email || "",
          Phone: mobile,
          country_code: selectedCountry,
          action: singInType === "signup" ? "SIGNUP" : undefined,
        };
        await axiosClient
          .post("otp/SendOtp", userData)
          .then(function (response) {
            if (response.data.statusCode == 200) {
              setReceivedOtp(response.data.data.otp);
              toast.success(`Code sent to Phone ${mobile}`);
              setStep(3);
            } else {
              toast.error(response.msg, { theme: "colored" });
            }
          });
      } catch (error) {
        console.error("Error during OTP sending:", error);
        toast.error("Error during OTP sending");
      }
    } else if (mobile.length !== 0) {
      toast.error("Enter valid mobile number");
    } else {
      toast.error("Select the country code");
    }
    setIsLoading(false);
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    const socialMedia = smData.token && smData.user && smData.user.Role;
    if (e.target.value.length == 4) {
      if (e.target.value == receivedOtp) {
        if (socialMedia) {
          localStorage.setItem("ACCESS_TOKEN", smData.token);
          localStorage.setItem("isLogin", true);
          localStorage.setItem("USER_DATA", JSON.stringify(smData.user));
          localStorage.setItem("USER_ROLE", smData?.user.Role);

          dispatch(
            userAction.setLoginInfo({
              token: smData.token,
              userInfo: smData.user,
            })
          );
          dispatch(getWishcount());
          if (isVendorDetailsPage) {
            // Redirect to the original URL (e.g., /vendordetails/438)
            navigate(intendedUrl.replace(/^\/home#/, ""), { replace: true });
          }
          //  else {
          //   navigate("/dashboardpage", { replace: true });
          // }
          // window.location.reload();
        } else if (responseData && responseData.user) {
          localStorage.setItem("ACCESS_TOKEN", responseData.token);
          localStorage.setItem("isLogin", true);
          localStorage.setItem("USER_DATA", JSON.stringify(responseData.user));
          localStorage.setItem("USER_ROLE", responseData.user.Role);
          dispatch(
            userAction.setLoginInfo({
              token: responseData.token,
              userInfo: responseData.user,
            })
          );
          dispatch(getWishcount());
          if (isVendorDetailsPage) {
            // Redirect to the original URL (e.g., /vendordetails/438)
            navigate(intendedUrl.replace(/^\/home#/, ""), { replace: true });
          }
          //  else {
          //   navigate("/dashboardpage", { replace: true });
          // }
          // window.location.reload();
        } else {
          console.log("No valid user data found");
        }
        toast.success("Login Successfully");
        closePopup();
        setStep(1);
      } else {
        console.log("OTP not matched");
      }
    }
  };

  const handleSignUpSubmit = (e) => {
    e.preventDefault();
    submitregForm();
  };

  const submitregForm = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!emailRegex.test(email)) {
      toast.error("Invalid email address");
      return;
    }
    if (!passwordRegex.test(password)) {
      if (password.length < 6) {
        toast.error("Password must have a minimum of 6 characters");
        return;
      } else if (!/(?=.*\d)/.test(password)) {
        toast.error("Password must contain at least one number");
        return;
      } else if (!/(?=.*[A-Z])/.test(password)) {
        toast.error("Password must contain at least one uppercase character");
        return;
      } else if (!/(?=.*[@$!%*?&])/.test(password)) {
        toast.error("Password must contain at least one special character");
        return;
      }
    }
    try {
      const response = await axiosClient.post("auth/register", {
        UserName: userName,
        Email: email,
        CountryCode: selectedCountry,
        Phone: mobile,
        Password: password,
        RoleID: 2,
        isVerified: 0,
      });
      if (response.data.statusCode === 200) {
        setResponseData(response.data);
        setStep(2);
      } else {
        toast.error(response.msg, { theme: "colored" });
      }
    } catch (error) {
      console.error("Error during SignUP:", error);
      if (error.response) {
        toast.error(error.response.data?.message || "Error during SignUP");
      } else if (error.request) {
        toast.error("No response from the server");
      } else {
        toast.error("Error during SignUP");
      }
    }
  };

  const handleRememberMeChange = (e) => {
    setRememberMe(e.target.checked);
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={closePopup}
      backdrop="static"
      size={`${step === 1 ? "lg" : "md"}`}
    >
      <ModalBody>
        <Row className="popup-container">
          {step === 1 && (
            <>
              <Col lg={5} sm={12} className="popup-left">
                <FacebookLogin
                  appId={process.env.REACT_APP_SSO_FACEBOOK_CLIENT_ID}
                  onSuccess={handleFBSuccess}
                  onFail={handleFbFail}
                  onProfileSuccess={handleFBProfileSuccess}
                  className="my-3"
                >
                  <div className="facebook-signin-button">
                    <span className="facebook-icon">
                      <FaSquareFacebook size={30} />
                    </span>
                    <span className="mx-auto inter-font">
                      Sign in with Facebook
                    </span>
                  </div>
                </FacebookLogin>
                <GoogleOAuthProvider
                  clientId={process.env.REACT_APP_SSO_GOOGLE_CLIENT_ID}
                  className="my-3"
                >
                  <GoogleLoginButton
                    handleSuccess={handleSuccess}
                    handleError={handleError}
                    type="popup"
                  />
                </GoogleOAuthProvider>
              </Col>
              <Col
                lg={2}
                sm={12}
                style={{
                  margin: 0,
                  height: "50vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                className="d-none d-md-block  d-lg-block vertical-line"
              >
                <div
                  style={{
                    position: "relative",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    height: "100%",
                  }}
                  className="d-none d-md-flex  d-lg-flex"
                >
                  <div
                    style={{
                      position: "absolute",
                      width: "2px",
                      height: "100%",
                      backgroundColor: "#d3d3d3",
                      zIndex: 1,
                    }}
                  />
                  <div
                    style={{
                      position: "relative",
                      width: "50px",
                      height: "50px",
                      backgroundColor: "rgba(255, 255, 255, 0.8)",
                      border: "2px solid #d3d3d3",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      zIndex: 2,
                      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <span
                      style={{
                        fontFamily: "Arial, sans-serif",
                        fontSize: "16px",
                        fontWeight: "bold",
                        color: "#806767",
                        textTransform: "uppercase",
                      }}
                    >
                      OR
                    </span>
                  </div>
                </div>
              </Col>
              <Col
                lg={2}
                sm={12}
                className="d-block d-md-none d-lg-none horizontal-line"
              >
                <div>
                  <div
                    style={{
                      position: "relative",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      height: "100%",
                    }}
                    className="d-block d-md-block  d-lg-none my-3"
                  >
                    <div
                      style={{
                        position: "absolute",
                        width: "100%",
                        height: "2px",
                        backgroundColor: "#d3d3d3",
                        zIndex: 1,
                        marginTop: "20px",
                      }}
                    />
                    <div
                      style={{
                        position: "relative",
                        width: "50px",
                        height: "50px",
                        backgroundColor: "rgba(255, 255, 255, 0.8)",
                        border: "2px solid #d3d3d3",
                        borderRadius: "50%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 2,
                        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                        margin: "auto",
                      }}
                    >
                      <span
                        style={{
                          fontFamily: "Arial, sans-serif",
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: "#806767",
                          textTransform: "uppercase",
                        }}
                      >
                        OR
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={5} sm={12} className="popup-right">
                <h2>Sign {singInType === "signup" ? "up" : "in"} manually</h2>
                {singInType === "signup" && (
                  <FormGroup className="form__group">
                    <Input
                      type="text"
                      required
                      placeholder="Username"
                      value={userName}
                      onChange={(e) => setUserName(e.target.value)}
                    />
                  </FormGroup>
                )}
                <FormGroup className="form__group">
                  <Input
                    className="form-control"
                    required
                    type="email"
                    name="email"
                    placeholder="Enter Your Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </FormGroup>
                {!forgot ? (
                  <FormGroup className="form__group input-container">
                    <Input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      required
                      placeholder="Enter Your Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="password-input"
                    />
                    <span
                      onClick={togglePasswordVisibility}
                      className="eye-icon"
                      style={{ top: "10px" }}
                    >
                      {showPassword ? (
                        <FaEyeSlash size={20} />
                      ) : (
                        <FaEye size={20} />
                      )}
                    </span>
                  </FormGroup>
                ) : (
                  <p className="mx-2 text-danger">
                    Enter Email to Send Reset Link
                  </p>
                )}
                <div className="popup-remember-me">
                  {singInType !== "signup" && (
                    <div className="d-flex align-items-center justify-content-center gap-2">
                      <input
                        type="checkbox"
                        id="remember"
                        className="m-0"
                        checked={rememberMe}
                        onChange={handleRememberMeChange}
                      />
                      <label htmlFor="remember" className="text-nowrap">
                        Remember me
                      </label>
                    </div>
                  )}
                  <button
                    onClick={(e) =>
                      singInType !== "signup"
                        ? handleLoginSubmit(e)
                        : handleSignUpSubmit(e)
                    }
                    className="popup-login-btn"
                  >
                    {singInType !== "signup"
                      ? forgot
                        ? "Submit"
                        : "Login"
                      : "Submit"}
                  </button>
                </div>
                <div className="popup-footer-links">
                  {singInType !== "signup" ? (
                    <>
                      <p onClick={() => setSingInType("signup")}>
                        Register now
                      </p>
                      <span>|</span>
                      <p>
                        <span
                          onClick={() => {
                            setForgot(!forgot);
                          }}
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          {!forgot ? `Forgot Password ?` : `Login`}
                        </span>
                      </p>
                    </>
                  ) : (
                    <div className="text-center">
                      Already have an account ?
                      <p onClick={() => setSingInType("signin")}> Login </p>
                    </div>
                  )}
                </div>
              </Col>
            </>
          )}
          {step === 2 && (
            <Col>
              <form className="auth__form">
                <FormGroup className="form__group">
                  <Label htmlFor="mobile" className="mb-0">
                    Mobile Number
                  </Label>
                  <div className="d-flex align-items-center login-ctr-select">
                    <Select
                      options={countryOptions}
                      placeholder="Select"
                      value={
                        selectedCountry
                          ? {
                              label: selectedCountry,
                              value: selectedCountry,
                            }
                          : null
                      }
                      onChange={(selectedOption) =>
                        setSelectedCountry(selectedOption.value)
                      }
                      styles={{
                        control: (styles) => ({
                          ...styles,
                          width: "100px",
                        }),
                        option: (styles) => ({
                          ...styles,
                          color: "black",
                          fontSize: "x-small",
                          width: "150px",
                        }),
                        menu: (styles) => ({
                          ...styles,
                          width: "150px",
                        }),
                      }}
                    />
                    <Input
                      className="form-control"
                      required
                      type="number"
                      name="mobile"
                      id="mobile"
                      placeholder="Enter Your Mobile Number"
                      value={mobile}
                      onChange={(e) => {
                        if (e.target.value.length <= 10) {
                          setMobile(e.target.value);
                        }
                      }}
                      maxLength={10}
                    />
                  </div>
                </FormGroup>
                <FormGroup className="form__group mt-2">
                  <button
                    onClick={handleOtpSent}
                    className="auth__btn"
                    disabled={isLoading}
                  >
                    Send Verification Code
                  </button>
                </FormGroup>
              </form>
            </Col>
          )}
          {step === 3 && (
            <form className="auth__form">
              <div>
                <p
                  onClick={() => {
                    setMobile("");
                    setSelectedCountry("+1");
                    setStep(2);
                  }}
                  style={{
                    cursor: "pointer",
                    position: "absolute",
                    top: "15px",
                    right: "56px",
                    fontSize: "18px",
                    color: "#000",
                    zIndex: 999,
                  }}
                >
                  <FaArrowLeft
                    style={{
                      marginRight: "6px",
                      marginTop: "-5px",
                    }}
                  />
                  Back
                </p>
              </div>
              <FormGroup className="form__group">
                <Label>OTP</Label>
                <Input
                  className="form-control"
                  required
                  type="text"
                  name="UserOTP"
                  placeholder="Enter OTP"
                  onChange={handleVerifyOtp}
                />
              </FormGroup>
              <Link onClick={handleOtpSent}>Resend Otp</Link>
            </form>
          )}
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default LoginPopUp;
